module.exports = global["jQuery"] = require("-!/Users/jennywissel/Server/sites/muhr/Sources/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/jquery/dist/jquery.js
// module id = 0
// module chunks = 0